module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "subinout.f62c91f1.png";